import { Helmet } from 'react-helmet-async';

function About() {
  return (
    <>
      <Helmet>
        <title>О нас | ИИ-Менеджер для Продаж 24/7</title>
        <meta name="description" content="Узнайте о нашей миссии: автоматизация продаж с помощью ИИ-консультанта, интеграция с CRM, Telegram, WhatsApp. Помогаем бизнесу расти и экономить!" />
        <meta name="keywords" content="ИИ консультант, о нас, автоматизация продаж, CRM интеграция, Telegram, WhatsApp, повышение конверсии" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />
        <meta name="author" content="ИИ Консультант" />
        <meta property="og:title" content="О нас | ИИ-Менеджер для Продаж 24/7" />
        <meta property="og:description" content="Мы создаём ИИ-консультантов для автоматизации продаж, интеграции с CRM и мессенджерами. Узнайте, как мы помогаем бизнесу!" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ailink.services/about" />
        <meta property="og:image" content="/images/ai-consultant.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="О нас | ИИ-Менеджер для Продаж 24/7" />
        <meta name="twitter:description" content="Мы создаём ИИ-решения для автоматизации продаж и интеграции с CRM. Узнайте больше о нашей миссии!" />
        <meta name="twitter:image" content="/images/ai-consultant.jpg" />
        <link rel="canonical" href="https://ailink.services/about" />
      </Helmet>

      <section className="section">
        <div className="container">
          <h2>О нас:</h2>
          <p>
            Мы — команда экспертов в области искусственного интеллекта Ailink, создающая инновационные решения для вашего бизнеса.
            Наши продукты работают 24/7, помогая автоматизировать продажи, сокращать затраты на сотрудников в два раза, а так же увиличивать конверсию.
                 </p>
                  <p>
            Мы интегрируем ИИ с популярными каналами связи — Telegram, WhatsApp, Instagram и вашим сайтом, а также с CRM-системами
            (Битрикс, amoCRM), чтобы обеспечить бесшовное управление клиентами.
          </p>
          <p>
            Наша миссия — упростить ваш бизнес, позволяя вам сосредоточиться на росте, пока ИИ берёт на себя рутинные задачи.
            Свяжитесь с нами, чтобы узнать, как мы можем помочь!

          </p>


        </div>
      </section>
    </>
  );
}

export default About;